<script>
    import Bar from './Bar.svelte';
    import BarItems from './BarItems.svelte';
    import BarItem from './BarItem.svelte';
    import images from './images.js';
    export let value, pulse, danger, title, icon, choices;
    const Icon = images[icon];
</script>


<Bar {icon} {value} {pulse} {danger}>
    <BarItem isTitle={true}>{title}</BarItem>
    <BarItem isIcon={true}><Icon /></BarItem>
    <BarItem isColon={true}>:</BarItem>
    <BarItems {value} {choices} />
    <BarItem isSpacer={true}></BarItem>
</Bar>